import { createSelector } from 'reselect';
import { MethodologyClusterState } from './models';

const getMethodologyClusterState = state => state?.MethodologyCluster;

export const getMethodologyClusters = createSelector(
  getMethodologyClusterState,
  (state: MethodologyClusterState) => state?.component_clusters
);

export const getClusterByComponentId = (componentId?: string) =>
  createSelector(getMethodologyClusters, clusters => {
    if (!componentId || !clusters) return null;
    const clusterIndex = clusters?.findIndex(clusterItem => clusterItem?.components_ids?.includes(componentId));

    if (clusterIndex === -1) return null;

    const cluster = clusters[clusterIndex];

    return {
      cluster,
      cluster_index: clusterIndex
    };
  });

export const getCharacteristicsIdsByPhenomenonIdExcludingCluster = (phenomenonId: string, excludeClusterId?: string) =>
  createSelector(getMethodologyClusters, clusters => {
    if (!clusters) return [];
    return clusters
      .filter(cluster => cluster?.phenomenon_id === phenomenonId && (!excludeClusterId || cluster?.id !== excludeClusterId))
      .flatMap(cluster => cluster?.components_ids);
  });

export const getUsedClusterNamesByPhenomenonId = (phenomenonId: string) =>
  createSelector(getMethodologyClusters, clusters => {
    if (!clusters) return [];
    return clusters
      .filter(cluster => cluster?.phenomenon_id === phenomenonId)
      .map(cluster => cluster?.name?.localized_strings?.en || '')
      .filter(name => name);
  });
